export default function useItineraryPackageReload(onTimeout?: () => void) {
    const itineraryStore = useItineraryStore();
    const packageSelectStore = usePackageSelectStore();
    return useReload({
        overrideCondition: () => itineraryStore.needsReloadPackageSet(),
        onTimeout: () => {
            itineraryStore.currentSetIndex = 0;
            packageSelectStore.clearSelectedPackages();
            onTimeout?.();
        },
    });
}
